// 统一的校验必填方法
var checkRequire = function (cardTypes, selectedCardList) {
  let required = false;
  let arrList = [...selectedCardList];
  arrList && arrList.forEach(item => {
    if (item && cardTypes.includes('' + item.card_type)) {
      required = true;
      return;
    }
  });
  return required;
};

var hasRequired = function (cardTypes, selectedCardList, isRequired, isNeedCard) {
  let cardList = [];

  if (isNeedCard) {
    cardList = selectedCardList;
  }

  return checkRequire(cardTypes, cardList) || isRequired;
};

module.exports = {
  hasRequired: hasRequired
};